<template>
    <div>
        <div class="mqMonitor-title">
            <div>{{ $t('alarms.queue.queue') }}</div>
            <div style="float: right;margin-top: -7px;">
                <add-message-queue></add-message-queue>
            </div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.queue.queue')">
                    <div class="mqMonitor-top">
                        <message-queue-search></message-queue-search>
                    </div>
                    <table-message-queue></table-message-queue>
                </TabPane>
            </Tabs>
        </template>
        
    </div>
</template>

<script>
    import MessageQueueSearch from '../mq/MessageQueueSearch'
    import TableMessageQueue from '../mq/TableMessageQueue'
    import AddMessageQueue from '../mq/AddMessageQueue'

    export default {
        name: 'MessageQueueMonitor',
        components: {
            MessageQueueSearch,
            TableMessageQueue,
            AddMessageQueue
        }
    }
</script>

<style scoped>
    .mqMonitor-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .mqMonitor-title>div:nth-child(1)
    {
        float:left;
    }
    .mqMonitor-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/mq/MessageQueueMonitor.vue